

/**
 * Partition array
 *
 * @param arr
 * @param size
 */
export function arrayChunk(arr:Array<any>, size:number){
	let arrChunk = [];
	let index = 0;
	
	while(index < arr.length){
		arrChunk.push(arr.slice(index, size + index));
		index += size;
	}
	
	return arrChunk;
}
